/**
 * assets/terms-checkbox.js
 *
 * Terms-and-Conditions-Checkbox oberhalb des Checkout-Buttons — für ALLE
 * Kunden (Reseller UND Endkunden), im Unterschied zu insurance-widget.js
 * (reseller-only).
 *
 * Steuert zwei Button-Typen gleichzeitig:
 * - [data-insurance-checkout-btn]    (unser Reseller "Protected checkout")
 * - [data-insurance-native-checkout] (nativer Shopify-Checkout-Button)
 *
 * Sperr-Mechanismus (bewusst KEIN natives `disabled`):
 * Ein natives `disabled`-Attribut würde Klicks komplett verschlucken —
 * damit könnten wir den Klick nicht abfangen, um die Popup-Meldung zu
 * zeigen. Stattdessen: `pointer-events:none` direkt auf dem Button, der
 * umgebende Container (`.cart__ctas`) bleibt klickbar und fängt den Klick
 * ab (der Browser macht beim Hit-Testing automatisch den Container zum
 * Ziel, wenn der Button pointer-events:none hat).
 *
 * Es kann mehrere Checkbox-Instanzen gleichzeitig im DOM geben (Drawer +
 * Cart-Seite). Beide werden synchron gehalten: Ändert sich eine, wird der
 * Zustand auf alle anderen übertragen.
 */
(function () {
  if (window.__termsCheckboxInitialized) return;
  window.__termsCheckboxInitialized = true;

  let termsAccepted = false;
  let textsPromise = null;
  let popupHideTimer = null;
  let popupText = "";

  function fetchTexts(lang) {
    if (textsPromise) return textsPromise;
    textsPromise = fetch(`/apps/insurance/terms-texts?lang=${lang}`)
      .then((r) => r.json())
      .catch(() => ({}));
    return textsPromise;
  }

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function setTermsCartAttributes() {
    const now = new Date();
    const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          tnc_term_and_condition: "cart",
          tnc_date: date,
          tnc_time: time,
        },
      }),
    }).catch((err) => console.error("[terms-checkbox] Cart-Attribute setzen fehlgeschlagen:", err));
  }

  function renderWidget(widget, t) {
    const prefixEl = widget.querySelector("[data-terms-prefix]");
    const suffixEl = widget.querySelector("[data-terms-suffix]");
    const linkEl = widget.querySelector("[data-terms-link]");
    if (!prefixEl || !suffixEl || !linkEl) return;

    const template = t.text || "{link}";
    const parts = template.split("{link}");
    prefixEl.textContent = parts[0] || "";
    suffixEl.textContent = parts[1] || "";
    linkEl.textContent = t.linkText || "";
    linkEl.href = t.url || "#";
  }

  function updateButtonsState() {
    document
      .querySelectorAll("[data-insurance-checkout-btn], [data-insurance-native-checkout]")
      .forEach((btn) => {
        btn.style.pointerEvents = termsAccepted ? "" : "none";
        btn.setAttribute("aria-disabled", String(!termsAccepted));
      });
  }

  function showPopup() {
    const popups = document.querySelectorAll("[data-terms-popup]");
    popups.forEach((p) => {
      if (popupHideTimer) clearTimeout(popupHideTimer);
      p.textContent = popupText;
      p.classList.add("is-visible");
    });
    popupHideTimer = setTimeout(() => {
      popups.forEach((p) => p.classList.remove("is-visible"));
    }, 6000);
  }

  function syncCheckboxes(checked, sourceInput) {
    termsAccepted = checked;
    document.querySelectorAll("[data-terms-checkbox-input]").forEach((input) => {
      if (input !== sourceInput) input.checked = checked;
    });
    updateButtonsState();
    if (checked) setTermsCartAttributes();
  }

  function wireCheckbox(widget) {
    const input = widget.querySelector("[data-terms-checkbox-input]");
    if (!input || input.dataset.termsWired) return;
    input.dataset.termsWired = "1";
    input.checked = termsAccepted;
    input.addEventListener("change", () => syncCheckboxes(input.checked, input));
  }

  // Fängt Klicks auf gesperrte Checkout-Buttons ab (siehe Kommentar oben zum
  // pointer-events-Trick) und zeigt die Popup-Meldung statt zum Checkout
  // weiterzuleiten.
  function wireButtonGuards() {
    document
      .querySelectorAll("[data-insurance-checkout-btn], [data-insurance-native-checkout]")
      .forEach((btn) => {
        const wrapper = btn.closest(".cart__ctas") || btn.parentElement;
        if (!wrapper || wrapper.dataset.termsGuardWired) return;
        wrapper.dataset.termsGuardWired = "1";
        wrapper.addEventListener(
          "click",
          (e) => {
            if (!termsAccepted) {
              e.preventDefault();
              e.stopPropagation();
              showPopup();
            }
          },
          true
        );
      });
  }

  async function init() {
    const widgets = document.querySelectorAll("[data-terms-widget]");
    if (widgets.length === 0) return;

    const lang = widgets[0].dataset.lang || "fr";
    const t = await fetchTexts(lang);
    popupText = t.popup || "";

    widgets.forEach((w) => {
      renderWidget(w, t);
      wireCheckbox(w);
    });
    wireButtonGuards();
    updateButtonsState();
  }

  function rewireAfterReload() {
    document.querySelectorAll("[data-terms-widget]").forEach((w) => wireCheckbox(w));
    wireButtonGuards();
    updateButtonsState();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Wenn cart.js / insurance-widget.js Cart-Sections neu laden (z.B. nach
  // Mengenänderung), werden Checkbox- und Button-DOM-Knoten ersetzt — neu
  // verdrahten, aber Zustand (termsAccepted) NICHT zurücksetzen.
  document.addEventListener("cart:updated", rewireAfterReload);
  document.addEventListener("cart:refresh", rewireAfterReload);

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      termsAccepted = false;
      init();
    }
  });
})();
